/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for VIPProfile model with nested risks
 * @export
 * @interface PatchedVIPProfile
 */
export interface PatchedVIPProfile {
    /**
     * 
     * @type {number}
     * @memberof PatchedVIPProfile
     */
    readonly id?: number;
    /**
     * Full name of the VIP person
     * @type {string}
     * @memberof PatchedVIPProfile
     */
    name?: string;
    /**
     * Profile picture of the VIP person
     * @type {string}
     * @memberof PatchedVIPProfile
     */
    profilePicture?: string | null;
    /**
     * Email address for contact
     * @type {string}
     * @memberof PatchedVIPProfile
     */
    email?: string;
    /**
     * Contact phone number
     * @type {string}
     * @memberof PatchedVIPProfile
     */
    phoneNumber?: string;
    /**
     * Professional title or position
     * @type {string}
     * @memberof PatchedVIPProfile
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedVIPProfile
     */
    readonly team?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedVIPProfile
     */
    readonly riskCount?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedVIPProfile
     */
    readonly activeRisks?: string;
}

/**
 * Check if a given object implements the PatchedVIPProfile interface.
 */
export function instanceOfPatchedVIPProfile(value: object): value is PatchedVIPProfile {
    return true;
}

export function PatchedVIPProfileFromJSON(json: any): PatchedVIPProfile {
    return PatchedVIPProfileFromJSONTyped(json, false);
}

export function PatchedVIPProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedVIPProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'profilePicture': json['profile_picture'] == null ? undefined : json['profile_picture'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phone_number'] == null ? undefined : json['phone_number'],
        'title': json['title'] == null ? undefined : json['title'],
        'team': json['team'] == null ? undefined : json['team'],
        'riskCount': json['risk_count'] == null ? undefined : json['risk_count'],
        'activeRisks': json['active_risks'] == null ? undefined : json['active_risks'],
    };
}

  export function PatchedVIPProfileToJSON(json: any): PatchedVIPProfile {
      return PatchedVIPProfileToJSONTyped(json, false);
  }

  export function PatchedVIPProfileToJSONTyped(value?: Omit<PatchedVIPProfile, 'id'|'team'|'risk_count'|'active_risks'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'profile_picture': value['profilePicture'],
        'email': value['email'],
        'phone_number': value['phoneNumber'],
        'title': value['title'],
    };
}

